const Minus_Icon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="white" />
      <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
      <path
        d="M21 14C21.5523 14 22 14.4477 22 15C22 15.5523 21.5523 16 21 16L9 16C8.44772 16 8 15.5523 8 15C8 14.4477 8.44772 14 9 14L21 14Z"
        fill="#006A76"
      />
    </svg>
  );
};

export default Minus_Icon;
